
import ImageHeader from '@/components/core/ImageHeader';
import PlaceCardv2Restaurant from '@/components/PlaceCardv2Restaurant'
import NoContent from "@/components/customer-content/NoContent";
import RestaurantCard from "@/components/RestaurantCard";
export default {
  components: {
    ImageHeader,
    NoContent,
    RestaurantCard,
    PlaceCardv2Restaurant
  },
  head() {
    return {
      title: this.title,
      meta: [{
        hid: "description",
        name: "description",
        content: this.description,
      },
      {
        hid: "keywords",
        name: "keywords",
        content: "best restaurants in goa, restaurants in goa, top 10 restaurants in goa, famous restaurants in goa, top restaurants in goa, pure veg restaurants in goa",
      },
      {
        hid: "og:title",
        property: "og:title",
        content: this.title,
      },
      {
        hid: "og:description",
        property: "og:description",
        content: this.description,
      },
      {
        hid: "twitter:title",
        property: "twitter:title",
        content: this.title,
      },
      {
        hid: "twitter:description",
        property: "twitter:description",
        content: this.description,
      },
      { hid: 'og:image:alt',
        property: 'og:image:alt',
        content: this.title ? this.title : 'Goa App'
      },
      { hid: 'og:image',
        property: 'og:image',
        content: this.$config.siteUrl + '/img/meta-imgs/dining-meta-image.webp'
      },
      { hid: 'image',
        property: 'image',
        content: this.$config.siteUrl + '/img/meta-imgs/dining-meta-image.webp'
      },
      { hid: 'twitter-image',
        property: 'twitter:image',
        content: this.$config.siteUrl + '/img/meta-imgs/dining-meta-image.webp'
      },
      ],
    };
  },

  jsonld() {
    return this.getJsonData()
  },

  data() {
    return {
      title: "Best Restaurants in Goa | Dining Experiences, Seafood, & More",
      description: "Discover Best Restaurant in Goa with best dining spots! From beachfront seafood to cozy veg restaurant, find your best restaurant near me. Book a table today!",
      eventCategoryModal: false,
      featuredCats: null,
      featuredCatsLoading: true,
      restaurantsList: [],
      loading: true,
      search: "",
      isSearchClicked: false,
      filters: {
        categories: [],
        allCategory: true,
        sortBy: "popular",
      },
      applyFilterClicked: false,
      skip: 0,
      page: 1,
      totalNumberOfpages: 0,
      listings: {},
      busy: false,
      productObj: [],
      schemaData: [],
      loading: true,
      listingLoading: true,
      initialLoading: true,
    }
  },
  mounted() {
    this.restListCall();
    this.getActitvitesCategoriesData();
    let pagination = (this.page - 1) * 12;
    if (pagination < 0) {
      pagination = 0;
    }

    this.getListings(
      pagination,
      this.search,
      this.filters.sortBy,
      this.filters.categories
    );
  },
  methods: {
    getJsonData() {
      console.log(this.schemaData)
      let structure = {
        "@context": "http://schema.org"
      }
      let data = this.schemaData.map((itm, index) => ({
        "@type": "LocalBusiness",
        "name": itm.post && itm.post.title ? itm.post.title : 'Restaurants in Goa',
        "image": itm.post && itm.post.gallery ? itm.post.gallery : [],
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": itm.post && itm.post.location ? itm.post.location.latitude : '',
          "longitude": itm.post && itm.post.location ? itm.post.location.longitude : ''
        },
        "address": {
          "@type": "PostalAddress",
          "streetAddress": itm.post && itm.post.location ? itm.post.location.address : '',
          "addressLocality": "Goa",
          "postalCode": "403001",
          "addressCountry": "IN"
        },
        priceRange: '',
        "review": {
          "@type": "Review",
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": itm.post && itm.post.rating ? itm.post.rating.averageRating : '',
            "bestRating": itm.post && itm.post.rating ? itm.post.rating.averageRating : '',
          },
          "author": {
            "@type": "Person",
            "name": "GoaApp"
          }
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": itm.post && itm.post.rating ? itm.post.rating.averageRating : '',
          "reviewCount": itm.post && itm.post.views ? String(itm.post.views.count).slice(0, 2) : ''
        },
      }))
      return {
        ...structure,
        ...data
      };
    },

    async getActitvitesCategoriesData() {
      this.featuredCatsLoading = true;
      this.featuredCats = await fetch(this.$config.fetchUrl + '/api/posts/app/getCategoriesForRestaurantsPageWithSlug').then(res =>
        res
          .text());
      this.featuredCats = this.getCryptKey(this.featuredCats);
      this.featuredCatsLoading = false;
    },
    async restListCall() {
      this.loading = true;
      this.restaurantsList = await fetch(this.$config.fetchUrl + '/api/posts/app/getDataForRestaurantsPage').then(res =>
        res
          .text());
      this.restaurantsList = this.getCryptKey(this.restaurantsList);
      this.loading = false;
    },
    isOffersSection(type) {
      switch (type) {
        case "cities":
          return 2
        default:
          return 1
      }
    },
    categoryBtnClicked(item) {
      if (item) {
        this.$router.push({
          path: item
        })
      }
    },
    activitiesImage(image) {
      if (image.length > 0) {
        return image[0];
      } else {
        return "";
      }
    },
    loadMore() {
      this.busy = false;
      if (this.listings.isMoreDataAvailable) {
        this.busy = true;
        setTimeout(() => {
          this.page++
          this.callback(this.page)
        }, 1000);
      }
    },
    // callback for the pagination plugin
    callback: function (page) {
      this.page = page;
      let pagination = (page - 1) * 12;
      if (pagination < 0) {
        pagination = 0;
      }
      if (
        (this.search && this.isSearchClicked) ||
        (this.filters.sortBy && this.filters.sortBy != "popular") ||
        (this.filters.categories && this.filters.categories.length > 0)
      ) {
        this.getListings(
          pagination,
          this.search,
          this.filters.sortBy,
          this.filters.categories
        );
      } else {
        this.getListings(pagination);
      }
    },
    // TO get SUBSCRIPTIONS using pagination
    getListings(skip, queryStr = null, sortBy = null, categories = null) {
      //if no categories are selected we can mkae a get request of the form /api/posts/app/getPostsOfType/places/:query/:pagination/:categories/:sortBy
      //the reason is POST requests cant be cached but get requests can so the data will load very fast when user hits back from a detail page
      //iF categories array pass the array in params

      var formData = new URLSearchParams();
      formData.append("skip", skip);
      if (queryStr) formData.append("query", queryStr.trim());
      if (sortBy) formData.append("sortBy", sortBy.trim());
      if (categories != null && categories.length > 0) {
        categories.forEach((category) => {
          formData.append("categories", category);
        });
      }
      if (categories != null && categories.length > 0) {
        categories = encodeURIComponent(JSON.stringify(categories));
      } else {
        categories = ["all"];
      }

      var query = "search";

      if (queryStr) {
        query = queryStr.trim();
      }

      // AXIOS api call to add review api
      this.$axios
        .get(
          `/api/posts/app/getFeaturedRestaurant/restaurants/${query}/${skip}/${categories}/${sortBy ? sortBy : "popular"
          }`
        )
        .then((response) => {
          this.applyFilterClicked = false;
          this.initialLoading = false;
          if (queryStr) this.isSearchClicked = true;
          let value = this.getCryptKey(response.data);
          this.listings = value;
          this.productObj.push(...value.posts)
          this.schemaData = this.listings && this.listings.posts ? this.listings.posts : [];
          if (skip == 0) {
            this.page = 1;
          }
          this.totalNumberOfpages = Math.ceil(this.listings.totalCount / 12);
          this.$nextTick(() => {
            this.busy = false;
            this.listingLoading = false;
            this.applyFilterClicked = false;
          });
        })
        .catch((error) => {
          this.$nextTick(() => {
            this.listingLoading = false;
            this.applyFilterClicked = false;
          });
        })
        .finally(() => {
          this.$nextTick(() => {
            this.listingLoading = false;
            this.applyFilterClicked = false;
          });
        });
    },
  }
}
